module.exports = __webpack_public_path__ + "media/index/cbs-logo-9d7d3b20.svg";